// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ldCE","requiredAsterisk":"Info_requiredAsterisk__2u1KF"};